var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#bda6cc",
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    stroke: "#bda6cc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.48,
    y: 18,
    width: 5.76,
    height: 11.52,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.12,
    y: 6.48,
    width: 5.76,
    height: 23.04,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 14.16,
    width: 5.76,
    height: 15.36,
    rx: 1,
    ry: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsSvgrepoCom);
export default __webpack_public_path__ + "static/media/reports-svgrepo-com.b166d482d68590fa75dd4fefe196293e.svg";
export { ForwardRef as ReactComponent };